/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `FormTheme*`'s.
 */
export type FormTheme = FormThemeDefault | FormThemeDark | FormThemeLite;

/**
 * The Form default theme type.
 */
export type FormThemeDefault = typeof FORM_THEME_DEFAULT;

/**
 * The Form dark theme type.
 */
export type FormThemeDark = typeof FORM_THEME_DARK;

/**
 * The Form lite theme type.
 */
export type FormThemeLite = typeof FORM_THEME_LITE;

/**
 * The Form default theme constant.
 */
export const FORM_THEME_DEFAULT = `default`;

/**
 * The Form dark theme constant.
 */
export const FORM_THEME_DARK = `dark`;

/**
 * The Form lite theme constant.
 */
export const FORM_THEME_LITE = `lite`;
